import type { GeolocationData } from './branchOffice.types';
import type { JwtProcessType } from '@features/certificates/types/certificate.types';

export interface NewCompanyStep1Data {
  fullName: string;
  name: string;
  code: string;
  numberId: string;
  dv: string;
  typeTaxpayer: string;
  phone: string;
  isLimited: boolean;
  logoFile: File | null;
}

export interface NewCompanyStep2Data {
  coordinates: { lat: number; lng: number } | null;
  geolocationData: GeolocationData | null;
  provinceId: string;
  districtId: string;
  townshipId: string;
  addressDetail: string;
  homeOrFloorNumber: string;
  fiscalCode: string;
}

export interface NewCompanyStep3Data {
  onlySignatureCert: boolean;
  signCertFile: File | null;
  authCertFile: File | null;
  certificatePassword: string;
  secretJwt: string;
  affiliationPac: boolean;
  jwtProcessType: JwtProcessType;
}

export interface NewCompanyWizardData {
  step1: NewCompanyStep1Data;
  step2: NewCompanyStep2Data;
  step3: NewCompanyStep3Data;
}

export const NEW_COMPANY_WIZARD_INITIAL_STATE: NewCompanyWizardData = {
  step1: {
    fullName: '',
    name: '',
    code: '',
    numberId: '',
    dv: '',
    typeTaxpayer: '',
    phone: '',
    isLimited: false,
    logoFile: null,
  },
  step2: {
    coordinates: null,
    geolocationData: null,
    provinceId: '',
    districtId: '',
    townshipId: '',
    addressDetail: '',
    homeOrFloorNumber: '',
    fiscalCode: '',
  },
  step3: {
    onlySignatureCert: false,
    signCertFile: null,
    authCertFile: null,
    certificatePassword: '',
    secretJwt: '',
    affiliationPac: false,
    jwtProcessType: 'none',
  },
};

export interface CreateCompanyPayload {
  code: string;
  name: string;
  fullName: string;
  dv: string;
  numberId: string;
  typeTaxpayer: '1' | '2';
  phone: string;
  profileImage?: string;
  addressId?: string;
  isLimited?: boolean;
}

export interface CreateCompanyResponse {
  company: {
    id: string;
    code: string;
    name: string;
    fullName: string;
    ruc: string;
    numberId: string;
    dv: string;
    typeTaxpayer: string;
    phone: string;
    profileImage?: string;
    addressId?: string;
    isLimited?: boolean;
  };
  /** false si la compañía se creó pero falló la configuración de facturación por defecto. */
  ebillSettingsCreated?: boolean;
}
